import { useState, useEffect } from 'react';
import api from '../services/api';
import DataTable from '../components/DataTable';
import UserForm from '../components/UserForm';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [filters, setFilters] = useState({
    search: ''
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, filters]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/auth/users');
      setUsers(response.data.data);
    } catch (err) {
      setError('Failed to fetch users');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...users];

    if (filters.search) {
      const search = filters.search.toLowerCase();
      filtered = filtered.filter(u =>
        u.name?.toLowerCase().includes(search) ||
        u.email?.toLowerCase().includes(search)
      );
    }

    setFilteredUsers(filtered);
  };

  const handleAdd = () => {
    setEditingUser(null);
    setShowForm(true);
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setShowForm(true);
  };

  const handleDelete = async (user) => {
    if (!window.confirm(`Are you sure you want to delete user "${user.name}"?`)) {
      return;
    }

    try {
      await api.delete(`/auth/users/${user._id}`);
      fetchUsers();
    } catch (err) {
      alert('Failed to delete user');
      console.error(err);
    }
  };

  const handleSave = async (data) => {
    if (editingUser) {
      await api.patch(`/auth/users/${editingUser._id}`, data);
    } else {
      await api.post('/auth/users', data);
    }
    setShowForm(false);
    fetchUsers();
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    {
      key: 'createdAt',
      label: 'Created',
      render: (val) => new Date(val).toLocaleDateString()
    }
  ];

  const renderFilters = () => (
    <div className="filters">
      <input
        type="text"
        placeholder="Search by name or email..."
        value={filters.search}
        onChange={(e) => setFilters({ ...filters, search: e.target.value })}
      />
    </div>
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div>
      {showForm ? (
        <UserForm
          user={editingUser}
          onSave={handleSave}
          onCancel={() => setShowForm(false)}
        />
      ) : (
        <DataTable
          data={filteredUsers}
          columns={columns}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onAdd={handleAdd}
          renderFilters={renderFilters}
        />
      )}
    </div>
  );
}
